import { useQuery } from '@apollo/client'
import * as LogCell from './LogCell'
import { gql } from '@apollo/client'

// Re-export gql for use in LogCell.js
export { gql }

const Cell = (props) => {
  const { QUERY, beforeQuery, Loading, Empty, Failure, Success } = LogCell

  if (!QUERY) {
    // LogCell doesn't have a default export, it's a cell with named exports
    return null
  }

  const queryOptions = beforeQuery ? beforeQuery(props) : { variables: props }
  const { data, loading, error } = useQuery(QUERY, {
    ...queryOptions,
    fetchPolicy: queryOptions.fetchPolicy || 'cache-and-network',
  })

  if (loading) {
    return Loading ? <Loading /> : <div>Loading...</div>
  }

  if (error) {
    return Failure ? <Failure error={error} /> : <div>Error: {error.message}</div>
  }

  if (!data || Object.keys(data).length === 0) {
    return Empty ? <Empty {...props} /> : null
  }

  // Extract the first key from data (RedwoodJS pattern)
  const dataKey = Object.keys(data)[0]
  const cellData = data[dataKey]

  return <Success {...props} {...{ [dataKey]: cellData }} />
}

export default Cell

